import type { ChangelogEntry } from "../types";

/** VIB-2928: budsjettlinjen fra godkjenningen fulgte ikke med til fordelingen ved bokføring. */
export const BILAG_LINJE_FRA_GODKJENNING_2026_10: ChangelogEntry = {
  id: "2026-10-24-bilag-linje-fra-godkjenning",
  date: "2026-10-24",
  title: "Budsjettlinjen fra godkjenningen følger bilaget til bokføring",
  summary:
    "Linjen produksjonslederen velger når et bilag godkjennes, brukes nå også når bilaget bokføres, så bilaget slipper å fordeles på nytt.",
  sections: [
    {
      heading: "Inne på et prosjekt",
      minRole: "user",
      items: [
        {
          title: "Bokførte bilag beholder linjen du valgte ved godkjenning",
          kind: "rettet",
          body: "Når et bilag ble bokført i PowerOffice, kom det inn ufordelt selv om du hadde valgt budsjettlinje ved godkjenningen, og linjen manglet kostnaden til noen fordelte det på nytt. Nå følger valget med når bilaget står på én kostnadslinje i PowerOffice. Er bilaget splittet på flere kontoer, kommer det fortsatt inn ufordelt.",
        },
      ],
    },
  ],
};
